import { render, staticRenderFns } from "./SeedPfAdviserRegionalData.vue?vue&type=template&id=32109a69"
import script from "./SeedPfAdviserRegionalData.vue?vue&type=script&lang=js"
export * from "./SeedPfAdviserRegionalData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports